import { IPaginate, ISmsTransaction, RootState, StoreState } from '@/types/types';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { isNetworkError } from '@/utils/helpers';
import { SmsTransactionsService } from '@/services/sms-transactions.service';
import * as qs from 'qs';

const state: StoreState<ISmsTransaction> = {
  all: [],
  paginate: {
    total: 0,
    page: 1,
    pages: 1,
    itemsPerPage: 15,
  },
};

const mutations: MutationTree<StoreState<ISmsTransaction>> = {
  UPDATE_LIST(state, payload: Array<ISmsTransaction>) {
    state.all = payload;
  },
  UPDATE_PAGINATION(state, payload: IPaginate) {
    state.paginate = payload;
  },
};

const actions: ActionTree<StoreState<ISmsTransaction>, RootState> = {
  async list({ commit, dispatch }, query: string) {
    try {
      dispatch('isPageLoading', true, { root: true });
      const options = qs.parse(query, { ignoreQueryPrefix: true });
      const response$ = await SmsTransactionsService.list(query);
      if (response$) {
        dispatch('isPageLoading', false, { root: true });
        if (!options?.download) {
          const { docs, page, pages, total, limit: itemsPerPage } = response$.data.paginateObj;
          commit('UPDATE_LIST', docs);
          commit('UPDATE_PAGINATION', { page, pages, total, itemsPerPage });
        } else {
          const { startDate, endDate, ext } = options;
          const blob = new Blob([response$.data], {
              type: 'application/octet-stream',
            }),
            a = document.createElement('a');
          a.download = `SMS-TX${startDate ? '-' + startDate : ''}${endDate ? '-' + endDate : ''}.${ext}`;
          a.href = URL.createObjectURL(blob);
          a.click();
          URL.revokeObjectURL(a.href);
        }
      }
    } catch (e) {
      if (isNetworkError(e)) {
        dispatch('snackBarMessage', e?.message, { root: true });
      } else {
        dispatch('snackBarMessage', e.response?.data?.message, { root: true });
      }
      dispatch('snackBarVisibility', true, { root: true });
      dispatch('isPageLoading', false, { root: true });
    }
  },
};

const getters: GetterTree<StoreState<ISmsTransaction>, RootState> = {
  getAllTransactions: state => state.all,
  getPagination: state => state.paginate,
};

export const smsTransactions: Module<StoreState<ISmsTransaction>, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
